{
  "erreurs.code.ANNONCE_DEJA_RETIREE": "This announcement has already been withdrawn: reload the list of announcements.",
  "erreurs.code.MAINTENANCE_CHEVAUCHEMENT": "Another scheduled or ongoing maintenance window overlaps this period.",
  "erreurs.code.MAINTENANCE_FIN_AVANT_DEBUT": "The maintenance window must end after it starts; an extension cannot shorten the window.",
  "erreurs.code.MAINTENANCE_HORS_ETAT": "This action is not possible in the current state of the maintenance window.",
  "erreurs.code.MAINTENANCE_PREAVIS_TROP_COURT": "Notice too short: it is below the platform minimum or the start is too close to honour it.",
  "journalAudit.action.platform.announcement_published": "Announcement published to organisations",
  "journalAudit.action.platform.announcement_withdrawn": "Announcement withdrawn",
  "journalAudit.action.platform.maintenance_cancelled": "Maintenance cancelled",
  "journalAudit.action.platform.maintenance_ended": "Maintenance ended",
  "journalAudit.action.platform.maintenance_extended": "Maintenance extended",
  "journalAudit.action.platform.maintenance_scheduled": "Maintenance scheduled",
  "journalAudit.action.platform.maintenance_started": "Maintenance started",
  "journalAudit.action.platform.status_published": "Status page updated",
  "journalAudit.action.platform.terms_published": "Terms of use published"
}
